import { render } from "./OrderFormComponent.vue?vue&type=template&id=b6fad4d0"
import script from "./OrderFormComponent.vue?vue&type=script&lang=js"
export * from "./OrderFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__